import { render } from "./PaymentOnBoarding.vue?vue&type=template&id=9644c222&scoped=true"
import script from "./PaymentOnBoarding.vue?vue&type=script&lang=js"
export * from "./PaymentOnBoarding.vue?vue&type=script&lang=js"

import "./PaymentOnBoarding.vue?vue&type=style&index=0&id=9644c222&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9644c222"]])

export default __exports__